import React from 'react';
import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TABLET_BREAKPOINT } from '../../../../Constants/constant';

const useStyles = makeStyles((theme) => ({
  li: {
    textAlign: 'left',
    padding: theme.spacing(1),
    paddingLeft: '5px',
  },
}));

const Declaration = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );

  return (
    <>
      <Box
        p={2}
        pb={10}
        width={isMobileScreen ? '100%' : '80%'}
        margin="0 auto"
      >
        <Typography
          fontWeight={600}
          variant="h4"
          color="primary"
          pt={3}
          align="left"
          textTransform="uppercase"
        >
          Declaration
        </Typography>
        <Box py={isMobileScreen ? 1 : 3}>
          <Divider />
        </Box>

        <Box pt={0}>
          <Typography
            fontWeight={500}
            color="primary"
            align="left"
            variant="subtitle2"
            fontSize={'16px'}
            sx={{ color: '#000000' }}
          >
            I, hereby, declare that the information entered by me in the
            Application Form are complete and true to the best of my knowledge
            and based on records.{' '}
          </Typography>
          <ul>
            <li className={classes.li}>
              I, hereby, declare that the information entered by me in the
              Application Form are complete and true to the best of my knowledge
              and based on records.
            </li>
            <li className={classes.li}>
              I, hereby, undertake to present the original documents upon demand
              by the concerned authorities at S P Jain School of Global
              Management.
            </li>
            <li className={classes.li}>
              I, hereby, agree to abide by the admission rules and regulations,
              as in force from time to time and subsequent
              changes/modifications/amendments made thereto.
            </li>
            <li className={classes.li}>
              I, hereby, undertake that should there be any false representation
              of any of the information provided in the application the School
              may it is discretion cancel my admission
            </li>
            <li className={classes.li}>
              I also understand that non-submission of any document/information
              as required by the School may lead to cancellation of admission
            </li>
            <li className={classes.li}>
              I, hereby, undertake to inform the Institute, about any changes in
              the information submitted by me, in the Application Form and any
              other documents, including changes in job, addresses and mobile
              nos., from time to time.
            </li>
          </ul>
          <Typography
            fontWeight={500}
            color="primary"
            align="left"
            fontSize={'16px'}
            sx={{ color: '#000000' }}
          >
            All disputes relating to admission process are governed under
            Australia Jurisdiction.
          </Typography>
        </Box>

        {/* <Box>
					<Typography
						fontWeight={500}
						color='primary'
						pb={2}
						align='left'
						variant='subtitle2'
						fontSize={"20px"}
					>
						Mandatory Documents
					</Typography>
					<Typography align='left'>
						Please ensure that you possess the following documents for upload
						before continuing
					</Typography>
					<ul>
						<li className={classes.li}>Birth Certificate</li>
						<li className={classes.li}>Aadhaar Card</li>
						<li className={classes.li}>Passport</li>
						<li className={classes.li}>Provisional Certificate</li>
					</ul>
				</Box> */}
      </Box>
    </>
  );
};

export default Declaration;
